import { useState } from 'react';
import { useDebouncedState } from '../../../hooks/use-debounced-state';
import { useSearchProducts } from './use-search-products';

export function useProductLookup(initialSearchTerm: string = '') {
  const [searchTerm, setSearchTerm] = useState<string>(initialSearchTerm);

  const debouncedTerm = useDebouncedState(searchTerm, 400);
  const query = debouncedTerm.trim() ? debouncedTerm : null;

  const { data: results, isFetching, isError, refetch } = useSearchProducts(query);

  return {
    searchTerm,
    debouncedTerm,
    setSearchTerm,
    results,
    isFetching,
    isError,
    refetch,
  };
}

export type ProductLookup = ReturnType<typeof useProductLookup>;
